import React from 'react'

import {
  ProjectCountTypeProvider,
  CategoryCountTypeProvider
} from '../UI/FormatProviders'
import DataGrid from '../UI/DataGrid'
import ProjectTypeCard from './ProjectTypeCard'

const ListProjectTypes = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Project type' },
    { name: 'projectCount', title: 'Projects' },
    { name: 'serviceCategoryCount', title: 'Service categories' }
  ]

  const gridRowMappingFn = projectType => {
    const id = projectType.id
    const { name, projectCount, serviceCategoryCount } = projectType.attributes

    return {
      id: id,
      name: name,
      projectCount: Number(projectCount),
      serviceCategoryCount: Number(serviceCategoryCount)
    }
  }

  const gridSorting = [{ columnName: 'name', direction: 'asc' }]

  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'projectCount', width: 200 },
    { columnName: 'serviceCategoryCount', width: 200 }
  ]

  // Formatted columns
  const typeProviders = [
    <ProjectCountTypeProvider for={['projectCount']} />,
    <CategoryCountTypeProvider for={['serviceCategoryCount']} />
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="project-types"
      resourceSingularName="project type"
      resourcePluralName="project types"
      nameAttribute="name"
      clientRootPath="/project-types"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      tableColumnExtensions={tableColumnExtensions}
      detailsCard={ProjectTypeCard}
      typeProviders={typeProviders}
    />
  )
}

export default ListProjectTypes



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/ListProjectTypes.jsx